interface ComputerWithGraphicsSVGProps {
  color: string;
  style: React.CSSProperties;
}

const ComputerWithGraphicsSVG = ({
  color,
  style,
}: ComputerWithGraphicsSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="59"
    height="50"
    viewBox="0 0 59 50"
    fill="none"
  >
    <g clipPath="url(#clip0_1655_19590)">
      <path
        d="M37.3682 49.2961V40.6318H21.668V49.2925"
        stroke={color}
        strokeWidth="1.44231"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.2832 49.2959H46.3929"
        stroke={color}
        strokeWidth="1.44231"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.74248 0.960938H54.9102C56.4464 0.960938 57.6917 2.19533 57.6917 3.71809V37.6269C57.6917 39.1496 56.4464 40.384 54.9102 40.384H3.74248C2.20625 40.384 0.960938 39.1496 0.960938 37.6269V3.71809C0.960937 2.19533 2.20625 0.960938 3.74248 0.960938Z"
        stroke={color}
        strokeWidth="1.44231"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.5402 17.4651C27.7831 17.4651 28.7198 16.3231 28.4712 15.1018C27.3796 9.81677 22.6998 5.84668 17.0941 5.84668C11.4884 5.84668 6.80861 9.82037 5.71702 15.1018C5.46483 16.3195 6.40152 17.4651 7.64802 17.4651H26.5438H26.5402Z"
        stroke={color}
        strokeWidth="1.44231"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1561 16.0709L9.89062 14.0498"
        stroke={color}
        strokeWidth="1.44231"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9355 17.2357C13.9355 15.492 15.3514 14.0762 17.095 14.0762C18.8387 14.0762 20.2546 15.492 20.2546 17.2357H13.9391H13.9355Z"
        stroke={color}
        strokeWidth="1.44231"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.30126 34.2278C6.05836 34.2278 5.12168 33.0858 5.37026 31.8645C6.46185 26.5795 11.1417 22.6094 16.7473 22.6094C22.353 22.6094 27.0328 26.5831 28.1244 31.8645C28.3766 33.0822 27.4399 34.2278 26.1934 34.2278H7.30126Z"
        stroke={color}
        strokeWidth="1.44231"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.6875 32.8336L23.953 30.8125"
        stroke={color}
        strokeWidth="1.44231"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.9088 33.9984C19.9088 32.2547 18.493 30.8389 16.7493 30.8389C15.0057 30.8389 13.5898 32.2547 13.5898 33.9984H19.9052H19.9088Z"
        stroke={color}
        strokeWidth="1.44231"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.1697 17.2349V12.3281H33.6016V17.2349"
        stroke={color}
        strokeWidth="1.44231"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.4926 17.2358V5.21387H40.9316V17.2358"
        stroke={color}
        strokeWidth="1.44231"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M52.8259 17.2353V9.69141H48.2578V17.2353"
        stroke={color}
        strokeWidth="1.44231"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M52.8252 17.2363H33.6016"
        stroke={color}
        strokeWidth="1.44231"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M52.8252 33.9973H33.6016V22.6094"
        stroke={color}
        strokeWidth="1.44231"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.6016 31.954L37.4456 28.11L39.2289 29.8933L44.2257 24.8965L49.0604 29.7312L53.3548 25.4333"
        stroke={color}
        strokeWidth="1.44231"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1655_19590">
        <rect
          width="58.6219"
          height="50.0657"
          fill={color}
          transform="translate(0.0332031 -0.260742)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default ComputerWithGraphicsSVG;
